import $ from 'jquery';
import _ from 'underscore';
import EditChecker from '../../components/EditChecker/EditChecker';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

const elementsMap = {

  //Review tab
  collateralNameVal : ".collateral-name-val",
  collateralDescVal : ".collateral-desc-val",
  collateralLongDescVal : ".collateral-long-desc-val",
  collateralTypeVal : ".collateral-type-val",
  collateralBarcodedVal : ".collateral-barcoded-val",
  reviewTabLengthVal : ".review-tab-length-val",
  reviewTabWidthVal : ".review-tab-width-val",
  reviewTabHeightVal : ".review-tab-height-val",
  reviewTabWeightVal : ".review-tab-weight-val",
  reviewNoRulesAlert : ".review-no-rules-alert",
  reviewRulesAlert : ".review-rules-alert",
  submitBtn : ".collateral-submit-btn"

};

export default function CollateralReviewTab(wizard) {
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const els = {};
  const namespace = wizardElement.data("namespace").trim();
  const submitURL = wizardElement.data("submit-collateral-url");
  const submitModalTitleTxt = wizardElement.data("submit-modal-title-txt");
  const submitModalBodyTxt = wizardElement.data("submit-modal-body-txt");
  const submitModalBtnTxt = wizardElement.data("submit-modal-btn-txt");

  self.init = function(){
    setMappings();
    setElements();
    bindElements();
  };

  self.didNavigateToForm = function(){
    fillCollateralAttributes();
    fillCollateralRules();
  };

  function bindElements() {
    els.submitBtn.on("click", function(e){
      e.preventDefault();
      showSubmitModal();
    });
  }

  function showSubmitModal() {
    const submitModalFlow = new SubmitModalFlow({
      confirmModalTitle: submitModalTitleTxt,
      confirmModalBody: `<div class="q-pad-all-xl">${submitModalBodyTxt}</div>`,
      confirmModalBtnText: submitModalBtnTxt,
      onConfirmClick: function() {
        submitModalFlow.showLoadingModal();
        saveNow();

        function saveNow() {
          $.ajax({
            data:  $('#new-collateral-wizard').serialize(),
            url: submitURL,
            dataType:"JSON",
            type: 'POST',
            success: submitCollateralSucess,
            error: submitCollateralError
          });
        }

        function submitCollateralSucess(itemId) {
          if(itemId > 0){
            EditChecker.setPageClean();
            submitModalFlow.showSuccessModal();
            const collateralDetailUrl = wizardElement.data("collateral-detail-url");
            setTimeout(function() {
              location.href = `${collateralDetailUrl}&${namespace}itemId=${itemId}`;
            }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
          } else {
            submitModalFlow.showFailureModal();
          }
        }

        function submitCollateralError() {
          submitModalFlow.hideAllModals();
        }
      }
    });
    submitModalFlow.init();
    submitModalFlow.showConfirmModal();
  }

  function fillCollateralAttributes() {
    els.collateralNameVal.html(els.collateralName.val());
    els.collateralDescVal.html(els.collateralDescription.val());
    els.collateralLongDescVal.html(els.collateralLongDescription.val());
    els.collateralTypeVal.html($('#'+namespace+'collateralType option:selected').text());
    els.collateralBarcodedVal.html(els.collateralBarcoded.val());
    els.reviewTabLengthVal.html(els.collateralLength.val() + " <strong>Inches</strong>");
    els.reviewTabWidthVal.html(els.collateralWidth.val() + " <strong>Inches</strong>");
    els.reviewTabHeightVal.html(els.collateralHeight.val() + " <strong>Inches</strong>");
    els.reviewTabWeightVal.html(els.collateralWeight.val() + " <strong>lbs</strong>");
    const handlingCheckBox = $('#excludePrepackagedProducts').is(':checked');
    if(handlingCheckBox) {
      $(".q-ppt-purple").show();
      $(".q-ppt-grey").hide();
    } else {
      $(".q-ppt-purple").hide();
      $(".q-ppt-grey").show();
    }
  }

  function fillCollateralRules() {
    $("#collateral-rules-review-table-body").empty();
    const collateralRulesCheckbox = $('input[name="collateralRules"]:checked');
    if(collateralRulesCheckbox.length > 0)
    {
       $(".review-rules-alert").show();
       $(".no-rules-alert").hide();
      collateralRulesCheckbox.each(function(){
      let checkbox = $(this);
      const data = getCheckboxRowDataFromCheckbox(checkbox);
      fillReviewTabTableNextRowWithData(data);
       });
    }
    else
    {
      els.reviewNoRulesAlert.show();
      $(".no-rules-alert").show();
      els.reviewRulesAlert.hide();
    }

  }

  $(document).on('click', "[data-target-form]", function(){
    const form = wizardElement.find($(this).data("target-form"));
    wizard.gotToForm(form);
  });

  function setElements(){
    setElementsFromScope(els, elementsMap, wizardElement);
  }

  function setElementsFromScope(targetObj, elementsDict, scope){
    _(elementsDict).each((v, k)=>{
      targetObj[k] = scope.find(v);
    });
  }

  function setMappings() {
    _.extend(elementsMap, {
      collateralName: `#${namespace}collateralName`,
      collateralDescription : `#${namespace}collateralDescription`,
      collateralLongDescription : `#${namespace}collateralLongDescription`,
      collateralType : `#${namespace}collateralType`,
      collateralBarcoded : `#${namespace}collateralBarcoded`,
      collateralUPC : `#${namespace}collateralUPC`,
      collateralLength : `#${namespace}collateralLength`,
      collateralWidth : `#${namespace}collateralWidth`,
      collateralHeight : `#${namespace}collateralHeight`,
      collateralWeight : `#${namespace}collateralWeight`,
      excludePkgProducts : `#excludePrepackagedProducts`
    });
  }

  function getCheckboxRowDataFromCheckbox(checkbox){
  const data = {};
  const row = checkbox.closest("tr");
  data.firstDataText = row.find('.first-element-containing-data').text();
  data.secondDataText = row.find('.second-element-containing-data');
  data.thirdDataText = row.find('.third-element-containing-data').val();
  data.forthDataText = row.find('.forth-element-containing-data');
  return data;
}

function fillReviewTabTableNextRowWithData(data){
  $(".collateral-rules-review-table").find('tbody')
      .append($('<tr><td> <div class="rule-name"><label for="rule-1" class="q-td-label">' +data.firstDataText + '</label></div></td>')
                .append('<td><div class="rule-desc"><label for="rule-1" class="q-td-label">' +data.secondDataText[0].innerHTML)
                .append('</label></div></td>')
                .append('<td><div class="rule-desc"><label for="rule-1" class="q-td-label">' + data.thirdDataText)
                .append('</label></div></td>')
        .append('<td><div class="rule-desc"><label for="rule-1" class="q-td-label">' + data.forthDataText[0].innerHTML)
                .append('</label></div></td></tr>')
              );

  $('.target-filling-element-1').text();
  $('.target-filling-element-2').text(data.secondDataText[0].innerHTML);
  $('.target-filling-element-3').text(data.thirdDataText[0].innerHTML);
  $('.target-filling-element-4').text(data.forthDataText[0].innerHTML);
}

}



// WEBPACK FOOTER //
// ./src/pages/products/CollateralReviewTab.js